import { signal } from '@lit-labs/signals';
import { LineItem } from '../_components/cart/line-item';

export interface ShippingMethodData {
    [handle: string]: {
        id: number;
        name: string;
        handle: string;
        priceAsCurrency: number;
    }
}

export interface AddressData {
    fullName?: string;
    addressLine1?: string;
    addressLine2?: string;
    locality?: string;
    postalCode?: string;
    countryCode?: string;
    administrativeArea?: string;
}

export interface ProductData {
    id: number;
    url: string;
}

export interface SnapshotData {
    product: ProductData;
}

export interface LineItemData {
    description: string;
    id: number;
    qty: number;
    totalAsCurrency: string;
	priceAsCurrency: string;
    snapshot: SnapshotData;
}

export interface CartData {
    lineItems: LineItemData[];
    totalAsCurrency: string;
    totalQty: number;
    email: string;
    shippingAddress?: AddressData;
    shippingMethodHandle?: string;
    availableShippingMethodOptions?: ShippingMethodData;
    number: number;
    gatewayId?: number;
    itemSubtotalAsCurrency: string;
    totalShippingCostAsCurrency: string;
    totalTaxAsCurrency: string;
}

class CartStore {

    message = signal<string|null>(null);
    data = signal<CartData|null>(null);

    async getCart() {
        const response = await fetch('/actions/commerce/cart/get-cart', {
            headers: { 'Accept': 'application/json' },
        });
        const result = await response.json();
        this.data.set(result.cart);
        return(result.cart);
    }

    async updateCart(formData: FormData) {
        try {
            const response = await fetch('/actions/commerce/cart/update-cart', {
                credentials: 'include',
                method: 'post',
                headers: { 'Accept': 'application/json' },
                body: formData,
            });
			if (response.ok) {
                await this.getCart();
            }
			const result = await response.json();
            this.message.set(result.message);
            return result;
        } catch (error) {
            console.error(error.message);
        }
    }

    async updateLineItem(lineItem: LineItem) {
        const formData = new FormData();
        formData.append(
            `lineItems[${ lineItem.id }][qty]`,
            String(lineItem.qty));
        formData.append(CRSF_TOKEN_NAME, CRSF_TOKEN);
        await this.updateCart(formData);
    }

}

export const cartStore = new CartStore();
cartStore.getCart();